/**
 * Format price with currency symbol
 * @param {number} price - The price to format
 * @param {string} currencySymbol - Optional currency symbol (defaults to "د.إ")
 * @returns {string} Formatted price string (without symbol, use CurrencyIcon component separately)
 */
export const priceFormatter = (price, currencySymbol = "د.إ") => {
  // Format number with locale-specific formatting
  const numberFormatter = new Intl.NumberFormat("en-AE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const formattedNumber = numberFormatter.format(price);
  // Return just the formatted number (currency icon should be added separately)
  return formattedNumber;
};
